// src\app\forms\LseSearchForm.jsx

import React from "react"
import TextField from "@mui/material/TextField"
import clearButton from "./ClearButton"
import { LAYOUT } from "../modules/constants"

const LseSearchForm = ({ handleSearchStringChange, handleSearchStringClear, label, onKeyPress, searchString, tabIndex }) => {
  const textInput = React.useRef(null)

  return (
    <form>
      <div className="field" style={{ marginBottom: 0 }}>

        <TextField
          style={{ marginTop: 5, marginBottom: 10, paddingRight: LAYOUT.COLUMN_PADDING, backgroundColor: "white" }}
          id="lseSearchFormTextField"
          variant="outlined"
          label={label}
          // Use 'defaultValue', rather than 'value' as this enables us to maintain the cursor position when editing.
          // 'defaultValue' is 'uncontrolled' - as opposed to 'controlled'- and handled by the DOM itself and not by React state.
          defaultValue={searchString}
          fullWidth
          InputProps={clearButton({ searchString, handleSearchStringClear, tabIndex, textInput })}
          // eslint-disable-next-line
          inputProps={{ spellCheck: "false" }}
          onChange={e => handleSearchStringChange({ e })}
          onKeyPress={e => onKeyPress(e)}
          inputRef={textInput}
        ></TextField>

      </div>
    </form>
  )
}

export default LseSearchForm